import UserRole from "../../../../common/types/user-role";
import RouteItemDefinition from "../../../../routes/types/route-item-definition";
import OrderOptimizerDetailsComponent from "../../order-optimizer-details.component";
import OrderOptimizerListingComponent from "../../order-optimizer-listing.component";
import orderOptimizerRoutesUrls from "./order-optimizer-routes-urls";

const orderOptimizerRoutesDefinition: RouteItemDefinition[] = [
  {
    path: orderOptimizerRoutesUrls.listing,
    component: <OrderOptimizerListingComponent />,
    userRolesWhitelist: [
      UserRole.ADMIN,
      UserRole.OPERATOR,
      UserRole.DEALER,
      UserRole.DISPATCHER,
    ],
  },
  {
    path: orderOptimizerRoutesUrls.details,
    component: <OrderOptimizerDetailsComponent />,
    userRolesWhitelist: [
      UserRole.ADMIN,
      UserRole.OPERATOR,
      UserRole.DEALER,
      UserRole.DISPATCHER,
    ],
  },
];

export default orderOptimizerRoutesDefinition;
